import React from "react";
import "./Fether.css";
import Layout from "../Components/Website/Layout";
import { Card } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBookOpen,
  faFilePen,
  faChartLine,
  faCalendarCheck,
  faChalkboardTeacher,
  faCirclePlay,
} from "@fortawesome/free-solid-svg-icons";

export default function Fether() {
  const features = [
    {
      icon: faBookOpen,
      title: "شرح مبسط ومركز",
      description: "شرح النظريات والمفاهيم زي ما بتفهمها في حياتك اليومية، بعيد عن التعقيد الأكاديمي.",
      color: "gold-grad",
      cardClass: "bento-tall",
    },
    {
      icon: faFilePen,
      title: "نماذج امتحانات بنفس النظام",
      description: "امتحانات تفاعلية بنفس شكل امتحانات الثانوية العامة، عشان تعيش جو الامتحان على المنصة.",
      color: "maroon-grad",
      cardClass: "bento-small",
    },
    {
      icon: faChartLine,
      title: "متابعة دورية وتقييم مستمر",
      description: "تقدمك بيتراجع أسبوعياً، وبنقدملك توصيات حسب احتياجك، ومتابعة أول بأول مع ولي الأمر.",
      color: "gold-grad",
      cardClass: "bento-small",
    },
    {
      icon: faCalendarCheck,
      title: "خطة مذاكرة منظمة",
      description: "المنصة بتقدملك جدول مذاكرة جاهز حسب وقتك ومستواك، عشان تذاكر بتركيز وراحة.",
      color: "maroon-grad",
      cardClass: "bento-small",
    },
    {
      icon: faChalkboardTeacher,
      title: "تفاعل مباشر مع مستر محمود",
      description: "أي استفسار أو نقطة مش واضحة تسأل عنها ومستر محمود الصبروط وفريق المساعدين هيردوا عليك بشكل فوري.",
      color: "gold-grad",
      cardClass: "bento-small",
    },
    {
      icon: faCirclePlay,
      title: "فيديوهات مراجعة مركزة ليالي الامتحان",
      description: "فيديوهات مراجعة قصيرة مركزة على أهم النقاط اللي محتاج تذاكرها قبل ما تدخل قاعة الامتحان.",
      color: "maroon-grad",
      cardClass: "bento-wide",
    },
  ];

  return (
    <div className="fetcherElearnn-section">
      <Layout>
        <div className="section-title-wrapper text-center mb-5">
          <span className="section-subtitle">مميزات نوح أكاديمي ✨</span>
          <h2 className="section-title">إيه اللي هتلاقيه على المنصة؟</h2>
          <div className="section-title-line"></div>
        </div>

        <div className="bento-grid">
          {features.map((fet, idx) => (
            <div key={idx} className={`bento-card-wrapper ${fet.cardClass}`}>
              <Card className="feature-card h-100">
                <Card.Body className="feature-card-body">
                  <div className={`feature-icon-wrapper ${fet.color}`}>
                    <FontAwesomeIcon icon={fet.icon} className="feature-icon" />
                  </div>
                  <div className="feature-card-content">
                    <h3 className="feature-card-title">{fet.title}</h3>
                    <p className="feature-card-desc">{fet.description}</p>
                  </div>
                </Card.Body>
              </Card>
            </div>
          ))}
        </div>
      </Layout>
    </div>
  );
}
